import { createContext } from 'react';

const RevenueContext = createContext();

export default RevenueContext;